import { Cancel, Done, LoginTwoTone } from "@mui/icons-material";
import {
  Stack,
  TextField,
  Grid,
  IconButton,
  Alert,
  InputAdornment,
  Box,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext, PosizionamentoContext } from "../contexts";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import {getModalitaMenuCustom, Modalita_SoloUbicazione } from "../utilities";

const colonnaStato = {
  field: "",
  headerName: "Stato ",
  renderCell: (params) => {
    if (params.row.Ubicazione === "") {
      return (
        <Stack spacing={2}>
          <IconButton
            color="warning"
            aria-label="upload picture"
            component="span"
          >
            <Cancel />
          </IconButton>
        </Stack>
      );
    } else {
      return (
        <Stack spacing={2}>
          <IconButton
            color="success"
            aria-label="upload picture"
            component="span"
          >
            <Done />
          </IconButton>
        </Stack>
      );
    }
  },
};

const MagAssegnazioneUbicazionetoRifPaletta = () => {
  const [columns, setColumns] = useState([]);

  const { idMerce, codiceMenu } = useParams();
  const inputRef = useRef();
  const inputRef2 = useRef();
  let navigate = useNavigate();

  console.log(codiceMenu)

  const {
    state: { magMovim, displayText, customColumn },
    getBarcodeInfo,
    postCambioUbicazione
  } = useContext(PosizionamentoContext);

    const {
      state:{
        visibleMenu,
        group
      },
  
      getMenuConfig
    } = useContext(AuthContext);

  useEffect(() => {
    if (idMerce) {
      getBarcodeInfo(idMerce, navigate);
    }
    getMenuConfig();
  }, []);

  useEffect(() => {
    let colonne = [];
    if (idMerce && customColumn?.length > 0) {
      customColumn?.forEach((element, i) => {
        colonne = [
          ...colonne,
          {
            field:element.field,
            headerName:element.headerName,
            width: 250,
          },
        ];
      });
      colonne = [colonnaStato,...colonne];
      setColumns(colonne);
    }
  }, [customColumn]);


  const validations = [
    ({ Ubicazione }) =>
      isRequired(Ubicazione) || { Ubicazione: "*Ubicazione obbligatoria" },
  ];

  const {
    values: posizioneForm,
    changeHandler,
    touched,
    errors,
    isValid,
    setValues,
  } = useForm(
    {
      RiferimPaletta: "",
      Ubicazione: "",
      UbicazioneIniziale: "",
    },
    validations
  );

  const updateUb = () => {
    postCambioUbicazione(posizioneForm, codiceMenu);
    setValues({
      RiferimPaletta: "",
      Ubicazione: "",
    });
  };

  const onkeyEnter = (event) => {
    if (event === 13) {
      if (posizioneForm.RiferimPaletta && isValid) {
        postCambioUbicazione(posizioneForm, codiceMenu);
        setValues({
          RiferimPaletta: "",
          Ubicazione: "",
        });
        const timeout = setTimeout(() => {
          inputRef2.current.focus();
        }, 100);

        return () => {
          clearTimeout(timeout);
        };
      }
    }
  };

  console.log(visibleMenu);

  const keyEnter = (event) => {
    if (event === 13) {
      const timeout = setTimeout(() => {
        inputRef.current.focus();
      }, 100);

      return () => {
        clearTimeout(timeout);
      };
    }
  };

  const getTextFieldEntitaPartenza = () => {
    let modalita = getModalitaMenuCustom(codiceMenu, visibleMenu );
    console.log("modalita", modalita)
    if (modalita === Modalita_SoloUbicazione) {
      return (

        <TextField
          id="outlined-basic"
          label="Ubicazione iniziale"
          variant="outlined"
          placeholder="Inserire l'ubicazione iniziale"
          fullWidth
          inputRef={inputRef2}
          autoFocus
          autoComplete={"off"}
          value={posizioneForm.UbicazioneIniziale || ""}
          onKeyPress={(e) => keyEnter(e.charCode)}
          onChange={(e) => changeHandler("UbicazioneIniziale", e.target.value)}
        />

      )
    } else {
      return (
        <TextField
          id="outlined-basic"
          label="Riferimento paletta"
          variant="outlined"
          placeholder="Inserire il riferimento paletta"
          fullWidth
          inputRef={inputRef2}
          autoFocus
          autoComplete={"off"}
          value={posizioneForm.RiferimPaletta || ""}
          onKeyPress={(e) => keyEnter(e.charCode)}
          onChange={(e) => changeHandler("RiferimPaletta", e.target.value)}
        />
      )
    }
  }

  return (
    <>
      <Grid container spacing={2} sx={{position:"fixed"}}>
        <Grid item xs={12} md={12} lg={12} m={2} >
          {/* <Alert severity="info">
            Movimentazione barcode:{" "}
            {
              <ReactMarkdown
                children={displayText ? displayText : ""}
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }{" "}
          </Alert> */}
          <Stack direction={"column"} spacing={2} mt={2}>
            
            {getTextFieldEntitaPartenza()}
            <TextField
              id="outlined-basic"
              label="Ubicazione"
              variant="outlined"
              placeholder="Inserire Ubicazione"
              error={Boolean(touched.Ubicazione && errors.Ubicazione)}
              helperText={touched.Ubicazione && errors.Ubicazione}
              fullWidth
              inputRef={inputRef}
              autoComplete={"off"}
              onKeyPress={(e) => onkeyEnter(e.charCode)}
              value={posizioneForm.Ubicazione || ""}
              onChange={(e) => changeHandler("Ubicazione", e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="primary"
                      disabled={!isValid}
                      onClick={() => updateUb()}
                    >
                      <LoginTwoTone />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Grid>
        {/* <Grid item xs={12} md={12} lg={12} m={1}>
          {columns.length > 0 ? (
            <Box sx={{ width: "100%" }}>

              <TableRowHtml customCol={columns} rows={magMovim} />
            </Box>
          ) : (
            <></>
          )}
        </Grid> */}
      </Grid>
    </>
  );
};

export default MagAssegnazioneUbicazionetoRifPaletta;
